import {SlimDeal} from "@irati/types"

export function formatGeoDealsAndMarkers(deals: SlimDeal[]) {
  const geoDeals: SlimDeal[] = []
  const geoMarkers: [] = []
  deals.forEach((deal, index) => {
    geoDeals.push({
      ...deal,
      index: index + 1
    })
  })
  return {geoDeals, geoMarkers}
}
